import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import GalleryGrid from '../GalleryGrid/GalleryGrid.vue';
import GalleryModalNew from './GalleryModalNew.vue';
import { nextTick, ref, useTemplateRef } from 'vue';
import type { GalleryElement } from '@/interfaces/components/galleryElement';
import BaseModal from '@lmt-rpb/BaseModal/BaseModal.vue';
import { useBaseModal } from 'src/storybook/src/composables/useBaseModal';

interface Props {
	galleryItems: GalleryElement[];
	headerTitle?: string;
	focusedIndex?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GalleryModalWithGrid',
  props: {
    galleryItems: {},
    headerTitle: { default: '' },
    focusedIndex: { default: 0 }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const [openGalleryGridModal] = useBaseModal('gridBaseModalRef');

const galleryModalRef = useTemplateRef('galleryModalRef');
const galleryGridRef = useTemplateRef('galleryGridRef');
const activeIndex = ref(0);

const openGalleryModal = (item: GalleryElement, index: number) => {
	activeIndex.value = index;
	galleryModalRef.value?.openModal();
};

const onOpen = async () => {
	await nextTick(() => {
		galleryGridRef.value?.focusElement(props.focusedIndex);
	});
};
const onArrowNavigation = (index: number) => {
	activeIndex.value = index;
};

__expose({
	openGalleryGridModal,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BaseModal, {
      ref: "gridBaseModalRef",
      "full-screen": "",
      "header-title": _ctx.headerTitle,
      class: "gallery-grid-modal",
      onOpen: onOpen
    }, {
      default: _withCtx(() => [
        (_ctx.galleryItems.length > 0)
          ? (_openBlock(), _createBlock(GalleryGrid, {
              key: 0,
              ref_key: "galleryGridRef",
              ref: galleryGridRef,
              items: _ctx.galleryItems,
              onItemClick: openGalleryModal,
              onItemArrowsNavigation: onArrowNavigation
            }, null, 8 /* PROPS */, ["items"]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["header-title"]),
    _createVNode(GalleryModalNew, {
      ref_key: "galleryModalRef",
      ref: galleryModalRef,
      elements: _ctx.galleryItems,
      "initial-index": activeIndex.value,
      "header-title": _ctx.headerTitle
    }, null, 8 /* PROPS */, ["elements", "initial-index", "header-title"])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})